import ComponentManagementPage from '../ComponentManagementPage/ComponentManagementPage';
import CrsSettingsPage from '../../components/CrsSettingsPage/CrsSettingsPage';
import Landing from "../../components/Landing";
import ProfilePage from '../../components/ProfilePage/ProfilePage';
import RedBookPageV2 from '../../components/RedBookPageV2/RedBookPageV2';
import TitleStatusPage from '../../components/TitleStatusPage/TitleStatusPage';
import UserManagementPage from '../../components/UserManagementPage/UserManagementPage';
import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "../Layout";
import Login from "../Login";
import NotFound from "../NotFound";
import StatutesPage from '../StatutesPage';
import UpdatedStatutes from "../UpdatedStatutes";
import AdministratorPage from './AdministratorPage/AdministratorPage';
import MarkedForDeletionPage from '../MarkedForDeletionPage/MarkedForDeletionPage';
import EditorialTemplatesPage from '../EditorialTemplatesPage/EditorialTemplatesPage';
import BillParserPage from '../BillParserPage/BillParserPage';
import OpsPage from '../OpsPage/OpsPage';
import TestPage from '../TestPage/TestPage';

type Props = {
  authenticated: boolean
}

const Routes: React.FC<Props> = ({ authenticated }) => {

  if (!authenticated) {
    return <Login />
  }

  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <Route path="/" exact component={Landing} />
          <Route path="/status" exact component={TitleStatusPage} />
          <Route path="/red-book/" exact component={RedBookPageV2} />
          <Route path="/red-book/:billNumber" exact component={RedBookPageV2} />
          <Route path="/red-book/:billNumber/:billSection" exact component={RedBookPageV2} />
          <Route path="/statutes" exact component={StatutesPage} />
          <Route path="/updated-statutes" exact component={UpdatedStatutes} />

          <Route path="/component/:title/:article/:section/:subsection/:paragraph/:subparagraph/:subSubparagraph" component={ComponentManagementPage} />
          <Route path="/component/:title/:article/:section/:subsection/:paragraph/:subparagraph" component={ComponentManagementPage} />
          <Route path="/component/:title/:article/:section/:subsection/:paragraph" component={ComponentManagementPage} />
          <Route path="/component/:title/:article/:section/:subsection" component={ComponentManagementPage} />
          <Route path="/component/:title/:article/:section" component={ComponentManagementPage} />
          <Route path="/component/:title/:article" component={ComponentManagementPage} />
          <Route path="/component/:title" component={ComponentManagementPage} />
          <Route path="/component" component={ComponentManagementPage} />

          <Route path="/admin/users" component={UserManagementPage} />
          <Route path="/admin" component={AdministratorPage} />
          <Route path="/bill-parser" component={BillParserPage} />
          <Route path="/ops" component={OpsPage} />
          <Route path="/crs" component={CrsSettingsPage} />
          <Route path="/profile" component={ProfilePage} />
          <Route path="/marked-for-deletion" component={MarkedForDeletionPage} />
          <Route path="/editorial-templates" component={EditorialTemplatesPage} />
          <Route path="/test" component={TestPage} />
          <Route path="*" exact component={NotFound} />
        </Switch>
      </Layout>
    </BrowserRouter>
  );

}

export default Routes;